import type { ToolModule } from '../../core/modules/types'
import { AuthTokenView } from './view'

export const authTokenModule: ToolModule = {
  id: 'auth-token',
  title: 'Token Minter',
  description: 'Mint a bearer token from sales-agent credentials (dev/staging).',
  View: AuthTokenView,
}
